import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import type { FootballFixture } from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import { EventTypeId } from '@swf/sports/types/eventType';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

interface Props<T extends FootballFixture> {
  enrichedParticipants?: EnrichedParticipants;
  fixture?: T;
}

const FootballScoreboard = <T extends FootballFixture>({
  enrichedParticipants,
  fixture
}: Props<T>) => {
  const [participantHome, participantAway] = enrichedParticipants ?? [];

  const currentScore = fixture?.score ?? null;

  return (
    <Scoreboard variant="lite">
      <ScoreboardParticipants>
        <ScoreboardParticipant name={participantHome.participant} />
        <ScoreboardParticipant name={participantAway.participant} />
      </ScoreboardParticipants>
      <ScoreboardScores>
        <ScoreboardScore
          score={[currentScore?.home ?? null, currentScore?.away ?? null]}
          scoreCharacterLength={getScoreCharacterLength(EventTypeId.SOCCER, [
            currentScore?.home ?? 0,
            currentScore?.away ?? 0
          ])}
        />
      </ScoreboardScores>
    </Scoreboard>
  );
};

export default FootballScoreboard;
